export default __webpack_public_path__ + "static/media/avatar_1.44893391.png";